import React from "react";
import { ReactSortable } from "react-sortablejs";
import "./index.css";
import { BsyUtils } from "../../utils/Utils";
import _ from "lodash";

class BsySortableColumns extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      titleField: props.titleField || "title",
      keyField: props.keyField || "id",
      itemsField: props.itemsField || "items",
      columnsItemClass: props.columnsItemClass || "",
      columns: props.columns || [],
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      titleField: nextProps.titleField,
      keyField: nextProps.keyField,
      itemsField: nextProps.itemsField,
      columnsItemClass: nextProps.columnsItemClass,
      columns: nextProps.columns,
    });
  }

  handleColumnChange = (newItems, sortable, store) => {
    const { columns, itemsField, keyField } = this.state;
    const columnId = store.dragging?.props?.["data-column-id"];

    if (!columnId) return;

    const newColumns = columns.map((col) => {
      if (col[keyField] === columnId) {
        return { ...col, [itemsField]: newItems };
      }
      return col;
    });

    this.setState({ columns: newColumns }, () => {
      // console.log("handleColumnChange", JSON.parse(JSON.stringify(newColumns)))
      if (this.props.onChange) {
        this.props.onChange(newColumns);
      }
    });
  };

  renderSortableColumns = (column) => {
    const { keyField, itemsField, columnsItemClass } = this.state;
    const apps = column[itemsField];
    const hasEmpty = BsyUtils.isObjectEmpty(apps);

    return (
      <ReactSortable
        list={column[itemsField]}
        setList={(newState) =>
          this.handleColumnChange(newState, null, {
            dragging: { props: { "data-column-id": column[keyField] } },
          })
        }
        group={{
          name: "shared",
          pull: true,
          put: true,
        }}
        onEnd={(event) => {
          // console.log("onEnd", event)
          if (this.props.onEnd) {
            this.props.onEnd(event);
          }
        }}
        onStart={(event) => {
          // console.log("onStart", event)
          if (this.props.onStart) {
            this.props.onStart(_.cloneDeep(column[itemsField][event.oldIndex]));
          }
        }}
        animati={150}
        forceFallback={true}
        className={`column-content ${columnsItemClass} ${
          hasEmpty ? "empty-group" : ""
        }`}
      >
        {hasEmpty && this.props.onEmptyGroup
          ? this.props.onEmptyGroup(column)
          : column[itemsField].map((item) => (
              <div
                key={item[keyField]}
                className="drag-item"
                data-id={item[keyField]}
              >
                {item.content}
              </div>
            ))}
      </ReactSortable>
    );
  };

  render() {
    const { columns, titleField, keyField, itemsField } = this.state;
    // console.log("BsySortableColumns render", JSON.parse(JSON.stringify(columns)))
    return (
      <div className="bsy-sortable-columns">
        <div className="columns-container">
          {columns.map((column) => {
            const key = `column-${column[keyField]}}`;
            // console.log("key", key, column[titleField]);
            return (
              <div key={key} className={`column id-${column[keyField]}`}>
                <div className="column-header">{column[titleField]}</div>
                {this.renderSortableColumns(column)}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default BsySortableColumns;
